import React from 'react';
import { Switch } from '@mui/material';

const DSSwitch = (props: React.ComponentProps<typeof Switch>) => {
  return <Switch {...props} />;
};

export default DSSwitch;
